import { LONG_PRESS_MS, MOVE_SLOP, TIP_SHOW_MS } from './touchRules';
const handlers = new Map();
let nextId = 0;
/**
 * For Tooltip: register how to show its own content. Put the returned `id` in the trigger's
 * `data-uxp-tip` attribute; call `unregister` on unmount.
 */
export const registerTouchTip = (show) => {
    const id = `t${++nextId}`;
    handlers.set(id, show);
    return { id, unregister: () => { handlers.delete(id); } };
};
const labelOf = (el) => {
    const label = el.getAttribute('title') || el.getAttribute('aria-label');
    // A visible caption already says it
    return label && !(el.textContent || '').trim() ? label : '';
};
/** The element under the finger that shows a label on a long press, or null */
export const findTouchTipTarget = (target) => {
    if (!(target instanceof Element))
        return null;
    const registered = target.closest('[data-uxp-tip]');
    const control = target.closest('button, a, [role="button"]');
    const labelled = control && labelOf(control) ? control : null;
    // The nearer of the two wins: an icon inside a Tooltip area shows its own label
    if (registered && labelled)
        return (registered.contains(labelled) ? labelled : registered);
    return (registered || labelled);
};
let pressTimer;
let hideTimer;
let start = null;
let shown = null;
const hide = () => {
    window.clearTimeout(hideTimer);
    shown === null || shown === void 0 ? void 0 : shown.hide();
    shown = null;
};
const showBubble = (el, text) => {
    let root = document.getElementById('portal-root');
    if (!root) {
        root = document.createElement('div');
        root.id = 'portal-root';
        document.body.appendChild(root);
    }
    const bubble = document.createElement('div');
    bubble.className = 'uxpcore_tooltip__content uxpcore_tooltip__content--top uxpcore_tooltip__content--arrow uxpcore_tooltip__content--touch';
    bubble.textContent = text;
    root.appendChild(bubble);
    // Above the control, kept 16px inside the screen; the arrow stays over the control
    const rect = el.getBoundingClientRect();
    const width = bubble.offsetWidth;
    const center = rect.left + rect.width / 2;
    const left = Math.min(Math.max(center - width / 2, 16), window.innerWidth - 16 - width);
    bubble.style.left = `${left}px`;
    bubble.style.bottom = `${window.innerHeight - rect.top + 8}px`;
    bubble.style.setProperty('--uxp-tip-arrow', `${center - left}px`);
    return { hide: () => bubble.remove() };
};
const show = (el) => {
    hide();
    const id = el.getAttribute('data-uxp-tip');
    const handler = id ? handlers.get(id) : undefined;
    if (handler) {
        handler(true);
        shown = { hide: () => handler(false) };
        return;
    }
    const text = labelOf(el);
    if (text)
        shown = showBubble(el, text);
};
if (typeof document !== 'undefined') {
    document.addEventListener('touchstart', (e) => {
        window.clearTimeout(pressTimer);
        hide();
        start = null;
        if (e.touches.length !== 1)
            return;
        const el = findTouchTipTarget(e.target);
        if (!el)
            return;
        start = { x: e.touches[0].clientX, y: e.touches[0].clientY };
        pressTimer = window.setTimeout(() => { start = null; show(el); }, LONG_PRESS_MS);
    }, { passive: true });
    document.addEventListener('touchmove', (e) => {
        if (!start)
            return;
        const t = e.touches[0];
        if (Math.abs(t.clientX - start.x) > MOVE_SLOP || Math.abs(t.clientY - start.y) > MOVE_SLOP) {
            window.clearTimeout(pressTimer);
            start = null;
        }
    }, { passive: true });
    const end = (e) => {
        window.clearTimeout(pressTimer);
        start = null;
        if (!shown)
            return;
        // The hold showed a label: no click
        if (e.type === 'touchend' && e.cancelable)
            e.preventDefault();
        window.clearTimeout(hideTimer);
        hideTimer = window.setTimeout(hide, TIP_SHOW_MS);
    };
    document.addEventListener('touchend', end, { passive: false });
    document.addEventListener('touchcancel', end, { passive: true });
    // The browser's own long-press menu would cover the label
    document.addEventListener('contextmenu', (e) => {
        if ((start || shown) && findTouchTipTarget(e.target))
            e.preventDefault();
    });
}
